import React, {useState} from "react";
import {
    notification,
    Popconfirm, Typography
} from 'antd';
import {Redirect} from "react-router-dom";
import {APIRequest} from "../shared/APIRequest";

const ProductDelete = (props) => {

    const [redirect, setRedirect] = useState(false);


    if (redirect) {
        return <Redirect to='/product'/>
    }

    return (
        <>
            <Popconfirm
                title="Czy na pewno usunąć ten produkt ?"
                onConfirm={() => {
                    APIRequest.delete('product/' + props.id, () => {
                        notification.success({
                            message: 'Usunięto produkt.'
                        });
                        setRedirect(true);
                    });
                }}
                onCancel={() => {
                }}
                okText="Tak"
                cancelText="Nie"
                placement="topRight"
            >
                <Typography.Text type="danger" className="clickable" underline>usuń produkt</Typography.Text>

            </Popconfirm>
        </>
    );
};

export {ProductDelete as default}